export default __webpack_public_path__ + "static/media/Chat.10a82993.svg";